export enum CoreCatalogApiTags {
  CatalogItemList = 'CatalogItemList',
  CatalogMapCatalogItemList = 'CatalogMapCatalogItemList',
}

export const coreCatalogApiTagTypes = Array.from(Object.values(CoreCatalogApiTags));
